/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

 import _ from "lodash"; 
 /**
  * This method is used to set the updated why asking list from contentstack
  * @param {Object} getWhyAskingForDropdown
  *
  */
 
 export const getWhyAskingForDropdown = (whyQuestionsList: Object) => {
   const whyQuestionsArray: Array<Object> = [];
   _.forEach(_.entries(Object(whyQuestionsList)), ([key, value]) => {
     let Obj: any = {};
     const data: any = value;
     Obj.title = data && data.value && data.value[0] && data.value[0].value;
     Obj.description = data && data.value && data.value[1] && data.value[1].value;
     whyQuestionsArray.push(Obj);
   });
   return whyQuestionsArray;
 };
 
 